import { useState } from "react";
import "../styles/contribution.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { serverURL } from '../config/urls';
import { useCareerContext } from './career-context';

export default function Contribution() {
    // null: no status yet
    // create: creating a new career page
    // feedback: leaving feedback on a career page
    // finish: finished creating a new career page
    const [pageStatus, setPageStatus] = useState(null);
    const [showExercisePopup, setShowExercisePopup] = useState(false);
    const [exerciseList, setExerciseList] = useState([]);
    const { handleError } = useCareerContext();

    
    function showPopup(e) {
        e.preventDefault();
        setShowExercisePopup(true);
    }

    function handleAddExercise(e) {
        const exercise = e.currentTarget.children[0].innerText;
        setExerciseList([...exerciseList, exercise]);
        setShowExercisePopup(false);
    }

    function removeExercise(idx) {
        const newList = exerciseList.filter((exercise, index) => index !== idx);
        setExerciseList(newList);
    }

    function handleNewCareerSubmit(e) {
        e.preventDefault();
        const form = e.target;
        let careerPage = {}
        careerPage["careerName"] = form.children[0].children[1].value;
        careerPage["exercises"] = [];
        console.log(form.children);
        for (let i = 1; i < form.children.length - 2; i++) {
            let exercise = {};
            exercise["name"] = form.children[i].children[0].children[0].innerText;
            for (let j = 1; j < form.children[i].children.length; j++) {
                let attribute = form.children[i].children[j].children[0].innerText;
                attribute = attribute.substring(0, attribute.length - 2);
                let value = form.children[i].children[j].children[1].value;
                exercise[attribute] = value;
            }
            careerPage["exercises"].push(exercise);
        }
        fetch(serverURL + "/add-page",
            {
                credentials: 'include', 
                method: "POST", 
                headers: {
                    "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('token')}`
                }, 
                body: JSON.stringify({ 
                    page: careerPage 
                })
            })
            .then(async response => {
                const { error, message } = await response.json();
                if (error) {
                    handleError(message)
                } else {
                    setPageStatus("finish");
                }

            })
            .catch(async err => {
                handleError("An unknown error occured")
            });


        
    }

    function handleFeedbackSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const career = form.children[0].children[1].value;
        const feedback = form.children[1].children[1].value;
        fetch(serverURL + "/feedback",
            {
                credentials: 'include', 
                method: "POST", 
                headers: {
                    "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('token')}`
                }, 
                body: JSON.stringify({ 
                    career: career,
                    feedback: feedback
                })
            })
            .then(async response => {
                const { error, message } = await response.json();
                if (error) {
                    handleError(message)
                } else {
                    setPageStatus("finish");
                }

            })
            .catch(async err => {
                handleError("An unknown error occured")
            });


    }

    const exercises = [
        {
            name: "Text",
            description: "Text section. Examples: explain how a financial analyst analyzes income statements, describe what a lawyer does.",
            attributes: [
                {
                    name: "Title"
                }, 
                {
                    name: "Body",
                    type: "textarea"
                }
            ]
        },
        {
            name: "Game",
            description: "A game to help the explorer learn about specific career skills, role play as a professional in that career, etc.",
            attributes: [
                {
                    name: "Description",
                    type: "textarea"
                }
            ]
        },
        {
            name: "Decision-Making Scenario",
            description: "A scenario where the explorer roleplays as a career professional and make decisions they might encounter using the information they learned. Multiple scenarios are welcome! Examples: a lawyer is going to court and has to make decisions throughout the hearing.",
            attributes: [
                {
                    name: "Scenario Description",
                },
                {
                    name: "Decision Choices",
                    type: "textarea"
                },
                {
                    name: "Outcomes",
                    type: "textarea"
                }

            ]
        },
        {
            name: "Free Response Question",
            description: "A free response question which will be graded by AI. Can test knowledge or just encourage thinking with no right answer(ex: what are some features this website should have?)",
            attributes: [
                {
                    name: "Question",
                },
                {
                    name: "Answer",
                    type: "textarea"
                }
            ]
        },
        {
            name: "Career Task",
            description: "A task that a career professional would do. Examples: a financial analyst analyzes a company's income statement, a software engineer writes a program.",
            attributes: [
                {
                    name: "Task Description",
                    type: "textarea"
                }
            ]
        },
        {
            name: "Project",
            description: "A project that a career professional would do. Examples: a ui/ux designer designs a website, a software engineer builds a calculator.",
            attributes: [
                {
                    name: "Project Description",
                    type: "textarea"
                }
            ]
        },
        {
            name: "Other",
            description: "Anything exercise you want to propose!",
            attributes: [
                {
                    name: "Description",
                    type: "textarea"
                }
            ]
        }
    ]

    return (
        <div className='contribution container'>

            {
                (() => {
                    if (pageStatus === null) {
                        return (
                            <div className='options' style={{display: 'grid', placeContent: 'center', height: "calc(100vh - 70px)"}}>
                                <div className="row" style={{gap: "10px"}}>
                                    <button onClick={() => setPageStatus("create")} className="primary-btn">Create New Page</button>
                                    <button onClick={() => setPageStatus("feedback")} className="primary-btn">Leave Feedback</button>
                                </div>
                            </div>
                        )
                    } else if (pageStatus === "create") {
                        return (
                            <div className="col center">
                                <h1>Create a Career Page</h1>
                                <form className="col contribution-form" onSubmit={handleNewCareerSubmit}>
                                    <div className="item col" style={{textAlign: "left"}}>
                                        <h3>Career Name <span className='red'>*</span></h3>
                                        <input type='text' required />
                                    </div>
                                    {
                                        exerciseList.map((exercise, idx) => {
                                            return (
                                                <div className="item col">
                                                    <div className="row" style={{justifyContent: "space-between"}}>
                                                        <h3>{exercise}</h3>
                                                        <span onClick={()=>removeExercise(idx)} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faTrashCan} /></span>
                                                        
                                                    </div>
                                                    {
                                                        exercises.filter(ex => ex.name === exercise)[0].attributes.map(attribute => {
                                                            return (
                                                                <div className="item col">
                                                                    <label>{attribute.name} <span className="red">*</span></label>
                                                                    {
                                                                        attribute.type === "textarea" ?
                                                                        <textarea required></textarea>
                                                                        :
                                                                        <input type="text" required/>
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                    

                                    <button className="add-btn" onClick={showPopup}>+ Add Exercise</button>
                                    <button className="primary-btn" style={{width: "fit-content", margin: "auto"}}>Submit</button>
                                </form>


                            </div>
                        )
                    } else if (pageStatus === "feedback") {
                        return (
                            <div className="col center">
                                <h1>Contact Us</h1>
                                <p style={{width: "700px", margin: "auto", textAlign: "left", marginBottom: "20px"}}>Any feedback or thoughts on any of the career pages are much appreciated! Please let us know how we can improve a career page.</p>
                                <form className="col contribution-form" onSubmit={handleFeedbackSubmit}>
                                    <div className="item col">
                                        <label>Career <span className="red">*</span></label>
                                        <input type='text' required />
                                    </div>
                                    <div className="item col">
                                        <label>Description <span className="red">*</span></label>
                                        <textarea style={{height: "400px"}} placeholder="Description of proposed edit..." required></textarea>
                                    </div>
                                    <button className="primary-btn" style={{width: "fit-content", margin: "auto"}}>Submit</button>
                                </form>

                            </div>
                        )
                    } else if (pageStatus === "finish") {
                        return (
                            <div className='center' style={{display: 'grid', placeContent: 'center', height: "calc(100vh - 70px)"}}>
                                <h1>Thanks for making Career Sample better!</h1>
                                <p>We are reviewing your feedback, talk to you soon!</p>
                                <button onClick={() => setPageStatus(null)} style={{width: "fit-content", margin: "auto", marginTop: "17px"}} className="primary-btn">Go Back</button>
                            </div>
                        )
                    }
                })()

            }
            {
                showExercisePopup &&
                <div className="popup-overlay" onClick={()=>setShowExercisePopup(false)} style={{display: "grid", placeContent: "center"}}>
                <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{width: "600px", maxWidth: "90vw", height: "95vh", margin: "0 auto"}}>
                    <button className="close-button" onClick={()=>setShowExercisePopup(false)}>×</button>
                    <div style={{height: "20px"}}></div>
                    <div className='col' style={{gap: "5px"}}>
                        {
                            exercises.map(exercise => {
                                return (
                                    <div className="exercise" onClick={handleAddExercise} key={exercise.name}>
                                        <strong style={{fontFamily: "Roboto, sans-serif", letterSpacing: "0.1px", fontSize: "17px"}}>{exercise.name}</strong>
                                        <p>{exercise.description}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    

                </div>
            </div>
            }
            
        </div>

    );
}

